class HHWaveAnimation extends HTMLElement {
  constructor() {
    super()
    this.footer = document.querySelector('.js-footer')
    this.main = document.querySelector('main')
    this.shopifySections = this.main.querySelectorAll('.shopify-section')

    this.prevRatio = 0.0
    this.backgroundPositionX = 0
    this.backgroundPositionStep = 10
    this.backgroundPositionIncrements = {
      desktop: 10,
      tablet: 5,
      mobile: 2,
    }

    this.screenSizes = {
      mediaM: '(max-width: 639px)',
      mediaT: '(min-width: 640px) and (max-width: 1023px)',
      mediaD: '(min-width: 1024px)',
    }

    this.observeOptions = {
      root: null,
      rootMargin: '0px',
      threshold: this.buildThresholdList(),
    }

    this.observer = new IntersectionObserver(
      this.onPageScroll.bind(this),
      this.observeOptions
    )
    this.observer.observe(this.footer)
  }

  connectedCallback() {
    this.observer.observe(this.footer)
    this.updateBackgroundPositionStep()

    setTimeout(() => {
      this.addPaddingToLastSection()
    }, 1000)
  }

  disconnectedCallback() {
    this.observer.disconnect()
  }

  onPageScroll(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > this.prevRatio) {
        this.backgroundPositionX += this.backgroundPositionStep
        this.style.backgroundPositionX = this.backgroundPositionX + 'px'
      } else {
        if (entry.intersectionRatio === 0) {
          this.backgroundPositionX = 0
        } else {
          this.backgroundPositionX -= this.backgroundPositionStep
        }
        this.style.backgroundPositionX = this.backgroundPositionX + 'px'
      }
      this.prevRatio = entry.intersectionRatio
    })
  }

  updateBackgroundPositionStep() {
    let self = this
    HH.mediaCheck({
      media: self.screenSizes.mediaD,
      entry: function () {
        self.backgroundPositionStep = self.backgroundPositionIncrements.desktop
      },
    })
    HH.mediaCheck({
      media: self.screenSizes.mediaT,
      entry: function () {
        self.backgroundPositionStep = self.backgroundPositionIncrements.tablet
      },
    })
    HH.mediaCheck({
      media: self.screenSizes.mediaM,
      entry: function () {
        self.backgroundPositionStep = self.backgroundPositionIncrements.mobile
      },
    })
  }

  buildThresholdList() {
    const thresholds = []
    const numSteps = 100
    for (let i = 1.0; i <= numSteps; i++) {
      let ratio = i / numSteps
      thresholds.push(ratio)
    }
    thresholds.push(0)
    return thresholds
  }

  addPaddingToLastSection() {
    const lastSection = [...this.shopifySections].at(-1)
    if (!lastSection) return

    const currentBottomPadding = getComputedStyle(lastSection).paddingBottom
    const waveHeight = getComputedStyle(this).height
    const safeOffset = '24px'
    lastSection.style.paddingBottom = `calc(${currentBottomPadding} + ${waveHeight} + ${safeOffset})`
  }
}

if (!customElements.get('hh-wave-animation')) {
  customElements.define('hh-wave-animation', HHWaveAnimation);
}
